/* eslint-disable no-undef */
import { apiWrapper } from '../apiWrapper';
import { EncompassApi } from '../../EncompassApi/EncompassApi';

export async function getUserGroups(token) {
	return await apiWrapper(getCompanyUserGroups, [...arguments]);
}

export const getCompanyUserGroups = async (token) => {
	return new Promise(async (resolve, reject) => {
		let api = new EncompassApi(token);
		try {
			let response = await api.getUserGroups();
			resolve(response)
		} catch (ex) {
			reject(ex);
		}
	});
};
